import { InnerBlocks } from '@wordpress/block-editor';

export default function Save() {
  return <InnerBlocks.Content />;
}
